import { api_mentionable_users_path } from '@routes';

import { CommentUser } from './comments';
import request from './request';

export type MentionableUsersParams = {
  articleId?: number;
  briefingId?: number;
  commentableId?: number;
  commentableType?: string;
  query: string;
};

export interface MentionableUsersResponse {
  users: CommentUser[];
}

export async function getMentionableUsers({
  articleId,
  briefingId,
  commentableId,
  commentableType,
  query,
}: MentionableUsersParams): Promise<MentionableUsersResponse> {
  const resp = await request('get', api_mentionable_users_path(), {
    name_fragment: query,
    article_id: articleId,
    briefing_id: briefingId,
    commentable_id: commentableId,
    commentable_type: commentableType,
  });
  return resp;
}
